<template>
  <div id="inner">
    <div class="row">
      <div class="col-12 text-center" >
        <h1>
            Bezig met laden...
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => {
      return {
      }
    },
    name: 'Home',
    mounted() {
        this.$emit('childInitialized', {
          title: 'Dit is de homepage'
        })
    },
    methods: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-icon {
    width: 100px;
}
</style>
